import React from 'react';
import { Link } from 'react-router-dom';
import Masonry from 'react-masonry-css';
import { posts } from './postsData';
import { stripHtml } from './utils';
import './PostList.css';

const PostList = () => {
  const getExcerpt = (content, length = 150) => {
    const text = stripHtml(content);
    return `${text.substring(0, length)}...`;
  };

  const breakpointColumnsObj = {
    default: 2,
    1100: 2,
    700: 1,
    500: 1
  };

  return (
    <div className="bg-black text-white pt-20 min-h-screen">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl md:text-5xl font-extrabold mb-12 text-center bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent pt-6" data-aos="fade-down">Stay Informed About Our Latest Perspectives</h1>
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="masonry-grid"
          columnClassName="masonry-grid_column"
        >
          {posts.map((post, index) => (
            <div key={post.id} data-aos="fade-up" data-aos-delay={index * 100}>
              <Link to={`/posts/${post.id}`}>
                <div className="bg-gray-900 rounded-xl overflow-hidden border border-gray-700 transition-all duration-300 transform hover:scale-105 hover:shadow-2xl hover:shadow-blue-500/50">
                  <img src={post.image} alt={post.title} className="w-full h-auto" />
                  <div className="p-8">
                    <h4 className="text-3xl font-bold text-white mb-2">{post.title}</h4>
                    <p className="text-gray-300 text-base mb-4">{getExcerpt(post.content, index % 2 === 0 ? 150 : 250)}</p>
                    <p className="text-blue-400 hover:text-green-400 transition-colors duration-300">Read More &rarr;</p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </Masonry>
      </div>
    </div>
  );
};

export default PostList;